module.exports = __webpack_public_path__ + "img/3.6f2989be.png";